import { Component, OnInit } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { Http } from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageBag, ValidationMessagesService } from 'ng2-custom-validation';
import { Router } from '@angular/router';
import { LocalStorage, SessionStorage } from "angular2-localstorage";
import { PushNotificationsService } from 'angular2-notifications';
import {IMyDpOptions} from 'mydatepicker';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { HeaderBarComponent } from '../header-bar/header-bar.component';

@Component({
  selector: 'app-kitty-party',
  templateUrl: './kitty-party.component.html',
  styleUrls: ['./kitty-party.component.css']
})
export class KittyPartyComponent implements OnInit {
	kittyForm : FormGroup;
	kitty:Object={};
  newdata=[];
	errorMessage:any[]=[];
	errors: MessageBag = new MessageBag();
   meridian = true;
    capcharesult:any;
   capcha:any;
   mydate=new Date();
  public myDatePickerOptions: IMyDpOptions = {       
        dateFormat: 'dd.mm.yyyy',
        disableUntil:{year: this.mydate.getFullYear(), month: this.mydate.getMonth() + 1, day: this.mydate.getDate() - 1}
  };
   settings={};
postData={};
  constructor(private kittyService: WebApiObservableService,private fb: FormBuilder,
        private validationMessagesService: ValidationMessagesService, private router: Router,private _pushNotifications: PushNotificationsService,private SettingService: HeaderBarComponent) { 
        	 _pushNotifications.requestPermission();
        }

  ngOnInit() {
  this.SettingService.callsettings((data) => {
        this.settings = data;
    });
  	this.kittyForm = this.fb.group({
            'name': ['', [
                Validators.required
            ]],
            'no_of_peoples': ['', [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(4)            
            ]],
            'date': ['', [
                Validators.required,           
            ]],
            'time': ['', [
                Validators.required,           
            ]],
            'special_instructions': ['', [
                Validators.required,           
            ]],
            'email': ['', [
                Validators.required,
                Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)               
            ]],
            'phone': ['', [
                Validators.required,
                
            ]],
            'capcha': ['', [
                Validators.required,
                
            ]]

        });
        this.validationMessagesService
            .seeForErrors(this.kittyForm)
            .subscribe((errors: MessageBag) => {
                this.errors = errors;
            });

             $('.spin').addClass('loading');
             /*Calling Api for generating Capcha*/
    this.kittyService
            .getCapchaService('/users/generate-random-string')
            .subscribe(
                result => {this.capcharesult = result;  $('.spin').removeClass('loading');},
                error => { $('.spin').removeClass('loading');   this.errorMessage = <any>error}
            );

  }


  OnKittySubmit(){  
  if(this.capcharesult === this.capcha){

      $('.spin').addClass('loading');
  this.newdata.push({'kittydata':this.kitty})
 
  this.postData={
      email:this.newdata[0].kittydata.email,
      name:this.newdata[0].kittydata.name,
      no_of_peoples:this.newdata[0].kittydata.no_of_peoples,
      phone:this.newdata[0].kittydata.phone,
      special_instructions:this.newdata[0].kittydata.special_instructions,
      time:this.newdata[0].kittydata.time.hour + ':' + this.newdata[0].kittydata.time.minute,
      date:this.newdata[0].kittydata.date.formatted,
      status:1
    };
   
    this.kittyService
            .createService('/kitty-party-reservations', this.postData)
            .subscribe(
                result => {
                   alert('Kitty Reservation Successful');
                   $('.spin').removeClass('loading');
                    this.router.navigate(["message"]);
                    let options = {
                      body: "Kitty Reservation Successful",
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                     
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                  },
                error => { $('.spin').removeClass('loading');   this.errorMessage = <any>error}
            );
  }else{
    alert('Wrong Capcha Code Entered');
  }
  
  }

}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/kitty-party/kitty-party.component.ts